import React, { useState, useEffect, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { CartContext } from "../CartContext";
import Success from "../Components/Success";
import ReactPixel from "react-facebook-pixel";
import { Helmet } from "react-helmet";
import { getData } from "../Api";

const options = {
  autoConfig: true,
  debug: false,
};
ReactPixel.init("419304844367207", options);
ReactPixel.pageView();

function DesiCowGhee() {
  const { slug } = useParams();
  const { addToCart } = useContext(CartContext);

  const [products, setProducts] = useState([]);
  const [categoryTitle, setCategoryTitle] = useState("");

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");

  const [addedToCart, setAddedToCart] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  // Fetch Category Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getData(`/category/${slug}`);

        setProducts(response.data || []);
        setCategoryTitle(response.title || "");

        setMetaTitle(response.meta_title || "Default Title");
        setMetaDescription(response.meta_description || "Default Description");
        setMetaKeywords(response.meta_keywords || "Default, Keywords");
      } catch (error) {
        console.error("Error fetching category products:", error);
        setProducts([]);
      }
    };

    fetchProducts();
  }, [slug]);

  // Add to Cart Handler
  const handleAddToCart = (item) => {
    addToCart(item);

    setToastMessage(`${item.title} added to cart successfully!`);
    setShowToast(true);

    setAddedToCart((prev) => ({
      ...prev,
      [item.id]: true,
    }));

    // Facebook Pixel Event
    ReactPixel.track("AddToCart", {
      content_ids: [item.id],
      content_type: "product",
      content_name: item.title,
      currency: "INR",
      value: item.discount_price,
    });
  };

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>

      <main className="container-fluid">
        <Header />
        <div
          className="row pagebgimg py-3"
          style={{
            backgroundImage: "url('../assets/img/Breadcrumbs Banner (1).png')",
          }}
        >
          <h1 className="text-center text-success fw-bold">{categoryTitle}</h1>
        </div>
        <section className="px-sm-5 py-5">
          <div className="row">
            {products.length > 0 ? (
              products.map((item) => (
                <div key={item.id} className="col-xl-3 col-lg-4 col-6 mb-4">
                  <div className="product-card">
                    <Link to={`/product/${item.slug}`} className="linktext">
                      <div>
                        <img
                          src={`${item.image}`}
                          className="product-image"
                          alt={item.title}
                        />
                      </div>
                      <h5 className="product-title">{item.title}</h5>
                      <p className="product-price">
                        {item.discount_price ? (
                          <>
                            <span className="text-dark discount-price me-2">
                              ₹{item.discount_price}
                            </span>
                            {/* <span className="original-price">
                              ₹{item.price}
                            </span> */}
                          </>
                        ) : (
                          <span className="discount-price">₹{item.price}</span>
                        )}
                      </p>
                    </Link>
                    <button
                      className="btn btn-cart"
                      onClick={() => handleAddToCart(item)}
                    >
                      {addedToCart[item.id] ? (
                        <>
                          <FaCheck size={16} className="me-1" /> Added
                        </>
                      ) : (
                        "Add To Cart"
                      )}
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center w-100">No products available</p>
            )}
          </div>
        </section>

        {/* ✅ Toast notification will be displayed here */}
        <Success
          showToast={showToast}
          setShowToast={setShowToast}
          toastMessage={toastMessage}
        />

        <Footer />
      </main>
    </>
  );
}

export default DesiCowGhee;
